import { CIP30 } from "@sundae/wallets";
import { ETransactionErrorState } from "../../../hooks/useTransactionErrorHandler";
import { ErrorHandler } from "../ErrorHandler.abstract.class";

export class EternlErrorHandler extends ErrorHandler {
  code?: number;

  constructor(public error: CIP30.TCIP30ErrorWithCode, public state: ETransactionErrorState) {
    super();
    if (!error.code) {
      return;
    }

    if (
      error.code === CIP30.TxSendErrorCode.Failure &&
      state === ETransactionErrorState.SEND &&
      error.info.includes("consumed") &&
      error.info.includes("produced")
    ) {
      this.code = 11;
    } else {
      this.code = error.code;
    }
  }

  shouldReport(): boolean {
    if (
      this.code === CIP30.TxSignErrorCode.UserDeclined &&
      this.state === ETransactionErrorState.SIGN
    ) {
      return false;
    }

    return true;
  }
}
